import { useContext } from "react";
import { TextField, Typography, Grid } from "@mui/material"
import { ToolContext } from "../../../../../core/context/ToolContext";

export const Appointment = ({ classes, d, currentStatus }) => {
    const { realproperty_state } = useContext(ToolContext);
    const { appntmntForm, inquiryForm } = realproperty_state;

    const handleDateTime = (e) => {
        const { name, value } = e.target
        appntmntForm.set((p) => ({
            ...p,
            [name]: {
                ...p[name],
                value,
                stat: name !== 'reason_for_cancelled' && value.trim() === ""
            }
        }))
    }

    return (
        <>
            <Grid item xs={12} sm={12} md={12}>
                <Typography mb='0.5rem'>Location:</Typography>
                <TextField size="small" fullWidth className={classes.tf} value={`${d?.street_building_number || ''} ${d?.barangay_name || ''} ${d?.city_name} ${d?.province_name}`} disabled/>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
                <Typography mb='0.5rem'>Time:</Typography>
                <TextField disabled={(currentStatus === 'appointment-scheduled' || currentStatus === 'appointment-completed' || currentStatus === 'deal-closed' || currentStatus === 'requirements-saved') || (currentStatus === 'appointment-cancelled' && inquiryForm.data?.status.value === 6)} name='time' type="time" size="small" fullWidth className={classes.tf} value={appntmntForm.data.time.value} onChange={handleDateTime} error={appntmntForm.data.time.stat}/>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
                <Typography mb='0.5rem'>Date:</Typography>
                <TextField disabled={(currentStatus === 'appointment-scheduled' || currentStatus === 'appointment-completed' || currentStatus === 'deal-closed' || currentStatus === 'requirements-saved') || (currentStatus === 'appointment-cancelled' && inquiryForm.data?.status.value === 6)} name='date' type="date" size="small" fullWidth className={classes.tf} value={appntmntForm.data.date.value} onChange={handleDateTime} error={appntmntForm.data.date.stat} 
                inputProps={{
					min: new Date().toISOString().split("T")[0], // today's date in YYYY-MM-DD
				}}/>
            </Grid>
            { inquiryForm.data.status.value === 6 && 
                <Grid item xs={12}>
                    <Typography mb='0.5rem'>Reason for Cancelled:</Typography>
                    <TextField disabled={currentStatus === 'appointment-cancelled'} name='reason_for_cancelled' size="small" fullWidth className={classes.tf} value={appntmntForm.data.reason_for_cancelled.value} onChange={handleDateTime} error={appntmntForm.data.reason_for_cancelled.stat} multiline inputProps={{ maxLength: 1000 }} sx={{ '& .MuiInputBase-input': { minHeight: '7.5rem', maxHeight: '15rem' } }}/>
                </Grid>
            }
        </>
    )
}
